const nlBlogHrGlas = {
  meta: {
    title: "Subsidie HR++ Glas 2026 | Bedragen & Aanvraag",
    description:
      "Hoeveel subsidie krijgt u voor HR++ glas in 2026 ? Bedragen, voorwaarden en aanvraag via ISDE. Bespaar op energiezuinig glas.",
  },
  hero: {
    h1: "Subsidie HR++ glas 2026 : bedragen en aanvraag",
    subtitle:
      "Welke subsidiebedragen gelden er voor HR++ glas in 2026 ? Ontdek de ISDE-regeling, voorwaarden en hoe u maximaal profiteert van energiebesparende beglazing.",
    image:
      "/img/27-energy-efficient-hr-double.jpg",
    updated: "Laatst bijgewerkt mei 2026",
    readTime: "7 min leestijd",
  },
  sections: {
    watIs: {
      h2: "Wat is HR++ glas en waarom subsidie ?",
      p1: "HR++ glas, ook wel hoogrendementsglas genoemd, is de standaard voor energiezuinige beglazing in Nederland. Deze dubbele beglazing bestaat uit twee glasplaten met een isolerende coating en een argongasvulling ertussen. De isolatiewaarde, uitgedrukt als U-waarde, ligt tussen 1,1 en 1,3 W/m²K — aanzienlijk beter dan enkel glas (5,7) of ouder dubbel glas (2,8).",
      p2: "De overheid stimuleert de vervanging van oude ramen door HR++ glas via de Investeringssubsidie Duurzame Energie (ISDE). Deze subsidie maakt het voor veel huiseigenaren financieel aantrekkelijk om te investeren in energiebesparing. Met stijgende energieprijzen verdient u de investering in HR++ glas binnen enkele jaren terug via lagere stookkosten.",
      p3: "Als erkend installateur in Eindhoven helpen wij u niet alleen met de plaatsing van HR++ glas, maar ook met het opstellen van de juiste documentatie voor uw subsidieaanvraag. Zo profiteert u maximaal van alle beschikbare regelingen.",
    },
    bedragen: {
      h2: "Subsidie HR++ glas 2026 : hoeveel krijgt u ?",
      intro:
        "De ISDE-subsidiebedragen voor HR++ glas in 2026 zijn afhankelijk van het type woning, de oppervlakte van het te vervangen glas en of u meerdere isolatiemaatregelen combineert.",
      p1: "Voor de vervanging van enkel glas door HR++ isolatieglas ontvangt u tussen de € 35 en € 65 per vierkante meter subsidie. Bij een gemiddeld rijtjeshuis met twaalf vierkante meter aan ramen loopt dit al snel op tot € 420 tot € 780. Kiest u voor triple glas (HR+++) met een U-waarde lager dan 0,9, dan stijgt het subsidiebedrag naar € 55 tot € 90 per m².",
      p2: "Combineert u glasvervanging met andere isolatiemaatregelen, zoals spouwmuurisolatie of vloerisolatie ? Dan kunt u aanspraak maken op een hoger totaalbedrag. De ISDE-subsidie is namelijk gebaseerd op een totaalpakket aan maatregelen. Wij adviseren u graag welke combinatie het meest voordelig is voor uw specifieke woning.",
      p3: "Daarnaast biedt de gemeente Eindhoven soms aanvullende subsidies of leningen voor energiebesparende maatregelen. Deze zijn te combineren met de landelijke ISDE in de meeste gevallen, waardoor uw totale voordeel verder oploopt.",
      linkIsde: {
        text: "Lees onze complete ISDE-subsidie 2026 gids",
        href: "/blog/isde-subsidie-2026/",
      },
    },
    triple: {
      h2: "HR++ vs HR+++ (triple glas) : welke kiezen ?",
      p1: "HR++ glas heeft een U-waarde van 1,1 tot 1,3 W/m²K en is voor de meeste Nederlandse woningen de beste keuze qua prijs-kwaliteitverhouding. Het biedt uitstekende isolatie, is relatief betaalbaar en komt in aanmerking voor een aantrekkelijke ISDE-subsidie.",
      p2: "HR+++ glas, ook triple glas genoemd, heeft een U-waarde van 0,5 tot 0,9 W/m²K en is daarmee nog energiezuiniger. Het bestaat uit drie glasplaten met twee argongasvullingen en extra isolerende coatings. De subsidie voor triple glas is hoger (€ 55 – € 90 per m²), maar de aanschafprijs ligt ook een stuk hoger dan HR++.",
      p3: "Voor bestaande woningen met oude kozijnen is HR++ vaak de meest praktische keuze, omdat het in bestaande kozijnprofielen past. Triple glas vereist meestal dikkere kozijnen. Wij meten ter plaatse of uw huidige kozijnen geschikt zijn voor triple glas, of dat vervanging van het kozijn noodzakelijk is.",
    },
    voorwaarden: {
      h2: "Voorwaarden voor de glas-subsidie",
      intro:
        "Niet elke vervanging van glas komt in aanmerking voor subsidie. Er gelden specifieke voorwaarden die u moet kennen voordat u start.",
      items: [
        {
          title: "Eigenaar-bewoner",
          text: "U moet zowel eigenaar als hoofdbewoner zijn van de woning waarin de beglazing wordt vervangen. Huurwoningen en vakantiewoningen komen niet in aanmerking voor de ISDE-subsidie.",
        },
        {
          title: "Minimale oppervlakte",
          text: "Per aanvraag moet minimaal 2 m² aan glas vervangen worden. In de praktijk komt vrijwel elke woning die van enkel naar dubbel glas gaat ruimschoots boven dit minimum uit.",
        },
        {
          title: "Erkend installateur",
          text: "De werkzaamheden moeten uitgevoerd worden door een erkend installateur. Wij zijn een erkend bedrijf en leveren de juiste factuur en specificaties voor uw aanvraag.",
        },
        {
          title: "Factuur en betaalbewijs",
          text: "Bij de aanvraag dient u een gedetailleerde factuur en betaalbewijs te uploaden. De factuur moet specifiek vermelden : type glas, U-waarde, oppervlakte en plaatsingsdatum.",
        },
        {
          title: "U-waarde eis",
          text: "Het geplaatste glas moet voldoen aan de minimale U-waarde-eis voor de subsidie. HR++ voldoet standaard, HR+++ biedt hogere subsidiebedragen.",
        },
      ],
    },
    aanvraag: {
      h2: "Zo vraagt u de subsidie aan",
      intro:
        "Het aanvragen van de ISDE-subsidie voor HR++ glas verloopt in een paar heldere stappen via mijn.rvo.nl.",
      steps: [
        {
          num: "1",
          title: "Vraag een offerte aan bij een erkend bedrijf",
          text: "Laat een offerte opstellen door een erkend installateur zoals Ramen Repair Eindhoven. Zorg dat de offerte specifiek vermeldt : type glas, U-waarde, totale oppervlakte en totaalprijs.",
        },
        {
          num: "2",
          title: "Laat het werk uitvoeren en bewaar de factuur",
          text: "Na plaatsing ontvangt u een gedetailleerde factuur. Bewaar ook het betaalbewijs. Deze documenten zijn essentieel voor uw aanvraag.",
        },
        {
          num: "3",
          title: "Log in op mijn.rvo.nl met DigiD",
          text: "Ga naar mijn.rvo.nl, log in met uw DigiD en selecteer de ISDE-subsidie. Vul uw gegevens in en upload de benodigde documenten.",
        },
        {
          num: "4",
          title: "Ontvang het subsidiebedrag binnen 4 tot 8 weken",
          text: "Na goedkeuring ontvangt u het subsidiebedrag op uw rekening. Bij vragen neemt de RVO contact met u op.",
        },
      ],
      linkIsde: {
        text: "Bekijk onze stap-voor-stap ISDE gids",
        href: "/blog/isde-subsidie-2026/",
      },
    },
    eindhoven: {
      h2: "HR++ glas laten plaatsen in Eindhoven",
      p1: "Als lokale specialist plaatsen wij HR++ glas in alle wijken van Eindhoven en omstreken. Van Strijp tot Gestel, van Centrum tot Woensel — wij kennen de typische woningbouwcijfers uit de jaren '50, '60 en '70 en weten precies welk type glas het best past bij uw kozijnen.",
      p2: "Wij werken uitsluitend met A-merk glas van gerenommeerde fabrikanten. Elke ruit wordt op maat gemaakt en professioneel geplaatst. Na oplevering ontvangt u een complete factuur met alle specificaties die u nodig heeft voor uw ISDE-aanvraag.",
      p3: "Bent u benieuwd naar de mogelijkheden voor uw woning ? Wij komen vrijblijvend langs voor een inspectie en een offerte op maat. Advies over subsidie is altijd gratis.",
      linkGlas: {
        text: "Bekijk onze glas vervangen service",
        href: "/glas-vervangen/",
      },
      linkKozijn: {
        text: "Bekijk onze kozijnreparatie service",
        href: "/kozijn-reparatie/",
      },
    },
  },
  faq: {
    h2: "Veelgestelde vragen over subsidie HR++ glas",
    items: [
      {
        q: "Hoeveel subsidie krijg ik voor HR++ glas in 2026 ?",
        a: "Voor HR++ glas ontvangt u tussen de € 35 en € 65 per m² subsidie via de ISDE-regeling. Bij een gemiddeld rijtjeshuis met 12 m² aan ramen loopt dit op tot € 420 – € 780. Triple glas levert een hoger subsidiebedrag op : € 55 – € 90 per m².",
      },
      {
        q: "Wat is het verschil tussen HR++ en triple glas ?",
        a: "HR++ glas bestaat uit twee glasplaten met een U-waarde van 1,1 – 1,3 W/m²K. Triple glas (HR+++) heeft drie glasplaten en een U-waarde van 0,5 – 0,9 W/m²K. Triple glas is energiezuiniger maar duurder en past niet altijd in bestaande kozijnen. HR++ is voor de meeste woningen de beste prijs-kwaliteitkeuze.",
      },
      {
        q: "Moet ik HR++ glas door een erkend bedrijf laten plaatsen ?",
        a: "Ja, voor de ISDE-subsidie moet het werk uitgevoerd worden door een erkend installateur. U heeft een gedetailleerde factuur en betaalbewijs nodig. Wij zijn een erkend bedrijf en leveren de juiste documentatie voor uw aanvraag.",
      },
      {
        q: "Kan ik subsidie voor glas combineren met andere isolatiemaatregelen ?",
        a: "Ja, de ISDE-subsidie wordt berekend over een totaalpakket aan maatregelen. Combineert u glasvervanging met bijvoorbeeld spouwmuurisolatie of vloerisolatie, dan komt u mogelijk in aanmerking voor een hoger totaalbedrag. Wij adviseren u graag over de meest voordelige combinatie.",
      },
    ],
  },
  disclaimer:
    "Subsidiebedragen en voorwaarden kunnen wijzigen. Raadpleeg altijd rvo.nl voor actuele informatie.",
  cta: {
    text: "HR++ glas met subsidie in Eindhoven ? Vraag gratis advies aan",
    phone: "040 798 7470",
  },
  schema: {
    headline:
      "Subsidie HR++ glas 2026 : bedragen en aanvraag",
    description:
      "Hoeveel subsidie krijgt u voor HR++ glas in 2026 ? Bedragen, voorwaarden en aanvraag via ISDE. Bespaar op energiezuinig glas.",
    author: "Ramen Repair Eindhoven",
    datePublished: "2026-05-28",
    dateModified: "2026-05-28",
  },
};

export default nlBlogHrGlas;